import { LedgerTypeKeys, LEDGER_TYPES } from "constants/ledgerEntryTypes";
import { useFormikContext } from "formik";
import { ReactNode } from "react";
import { roundToFixedDecimal } from "utils/roundtoFixedDecimal";
import { getAccrualEntries, getCashEntries } from "utils/journalEntryUtils";
import { JournalEntryTransaction } from "./AddJournalEntryModal";

export const JournalEntryFormWrapper = ({
  children,
}: {
  children: (arg: {
    isValidTransactions: boolean;
    isAmountMatch: boolean;
    cashAndAccrualMatch: boolean;
  }) => ReactNode;
}) => {
  const {
    values: { transactions, ledger_type, is_cash_same_as_accrual },
    isValid,
  } = useFormikContext<{
    transactions: JournalEntryTransaction[];
    ledger_type: LedgerTypeKeys;
    is_cash_same_as_accrual: boolean;
  }>();

  const noEntryData = transactions.some(
    ({ description, cash_category_id, accrual_category_id }) =>
      (!Boolean(cash_category_id) && !Boolean(accrual_category_id)) ||
      !Boolean(description)
  );

  const totalDebit = transactions.reduce(
    (acc, { debit }) => acc + Number(debit),
    0
  );

  const totalCredit = transactions.reduce(
    (acc, { credit }) => acc + Number(credit),
    0
  );

  const isAmountMatch =
    roundToFixedDecimal({ numberToRound: totalDebit }) ===
    roundToFixedDecimal({ numberToRound: totalCredit });

  const accrualSum = getAccrualEntries(transactions).reduce(
    (acc, { debit, credit }) => acc + Number(debit),
    0
  );

  const cashSum = getCashEntries(transactions).reduce(
    (acc, { debit, credit }) => acc + Number(debit),
    0
  );

  const cashAndAccrualMatch =
    is_cash_same_as_accrual ||
    (ledger_type === LEDGER_TYPES.PAYMENT_PROCESSOR
      ? accrualSum === cashSum
      : true);

  const isValidTransactions =
    transactions.length !== 0 &&
    isValid &&
    !noEntryData &&
    isAmountMatch &&
    cashAndAccrualMatch;

  return (
    <>{children({ isValidTransactions, isAmountMatch, cashAndAccrualMatch })}</>
  );
};
